<template>
  <div>
    <Head-section></Head-section>

      <img src="../assets/customize_en.jpg" class="img-fluid" alt="Customize Bluedio" v-if="lan=='en'">
      <img src="../assets/customize_cn.jpg" class="img-fluid" alt="Customize Bluedio" v-if="lan=='cn'">

    <Foot-section></Foot-section>
  </div>
</template>

<script>
import {  mapGetters } from "vuex";
// import HeadSection from "./HeadCommSection.vue";
import HeadSection from "./HeadSection.vue";
import FootSection from "./FootSection.vue";
export default {
  name: "Customize",
  components: { HeadSection, FootSection },
  computed: {
    ...mapGetters(["lan"])
  }
};
</script>
